import { makeStyles } from 'tss-react/mui';
import { PRIMARY_PAYMENT_DEFAULT, WHITE } from 'src/global/theme/colors';

export const styles = makeStyles()(() => {
  return {
    main: { 
        display: 'flex',
        flexDirection: 'column',
        textAlign: "center",
        padding: "48px",
        alignItems: "center",
        gap: "16px",
        alignSelf: 'center',
        justifyContent: 'center',
        height: '100%',
        marginTop: "120px 0"
    },
    button: { 
        color: WHITE, 
        backgroundColor: PRIMARY_PAYMENT_DEFAULT,
        textTransform: 'none',
        fontSize: '15px',
        padding: "8px 16px",
        borderRadius: "8px",
    },
    text: {
        fontSize: '20px',
        fontWeight: 400,
        lineHeight: '20px'
    },
  };
});
